import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { t, Trans } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import Image from "next/image";
import CustomAdornmentInput from "@/main/account/(withSidebar)/edit-account/_components/clipboard-input";
interface VoucherCodesProps {
  voucherItem: {
    jit_product_name: string;
    jit_product_image: string;
    jit_order_date_added: string;
    jit_order_id: string;
    jit_cashcode_or_pin_info?: string;
    jit_terms_and_cond_text?: {
      content: string;
    };
    secret_code: string;
    pin_code: string | null;
    barcode_popup_url: string;
  };
  handleModalBarcodeOpen: () => void;
}
const VoucherCodes: React.FC<VoucherCodesProps> = ({ voucherItem, handleModalBarcodeOpen }) => {
  const { i18n } = useLingui();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: { xs: "wrap", sm: "nowrap" },
          overflow: "hidden",
          gap: 1,
        }}
      >
        {voucherItem.jit_cashcode_or_pin_info === "" && (
          <CustomAdornmentInput placeholder={voucherItem.secret_code || ""} />
        )}
        {voucherItem.jit_cashcode_or_pin_info === "" && voucherItem.pin_code ? (
          <CustomAdornmentInput
            placeholder={voucherItem.pin_code}
            label={t(i18n)`PIN:`}
            sx={{ minWidth: { xs: "230px", md: "unset" } }}
          />
        ) : null}
      </Box>

      {voucherItem.barcode_popup_url && (
        <Box sx={{ mt: 1, display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <Button
            onClick={handleModalBarcodeOpen}
            data-testid="open-barcode-button"
            sx={{
              width: "50px",
              height: "50px",
              borderRadius: "50%",
              backgroundColor: "#fdfdfd",
              color: "#000000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              minWidth: 0,
            }}
          >
            <Image src="/vbarcode.svg" alt="barcode" width={50} height={50} />
          </Button>
          <Typography
            sx={{
              mt: "5px",
              fontWeight: 600,
              fontSize: "12px",
              color: "#000000",
              textAlign: "center",
              width: "50px",
            }}
          >
            <Trans>Scan</Trans>
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default VoucherCodes;
